import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AddProjectModal from '../../common/components/AddProjectModal';
// import {
//   isDSUrlvalid,
//   isUSTerritory,
// } from '../../common/helpers/projectInitUtil';
import './EmptyProjectPage.scss';

const EmptyProjectPage = () => {
  const [showModal, setShowModal] = useState(false);
  const { t } = useTranslation();

  return (
    <div className="empty-project-page">
      <h2>{t('WelcomeJunction')}</h2>
      <h2>{t('getStarted')}</h2>
      {/* Bug: 695447 - Commenting out the flags since from now we should always display the 2 texts */}
      {/* {isUSTerritory && isDSUrlvalid() && ( */}
      <>
        <p>{t('projectmsg1')}</p>
        <p>{t('projectmsg2')}</p>
      </>
      {/* )} */}
      <br />
      <AddProjectModal showModal={showModal} handleClose={setShowModal} />
    </div>
  );
};

export default EmptyProjectPage;
